import {
  HStack,
  Popover,
  PopoverAnchor,
  PopoverArrow,
  PopoverContent,
  useDisclosure,
} from '@chakra-ui/react';
import { Typography } from 'Tokens';
import { WarningIcon } from 'Tokens/Icons/Status';

export const SubsidiaryWarning = ({ isWordReport }: { isWordReport?: boolean }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom">
      <PopoverAnchor>
        <HStack gap="12px" alignItems="start" onMouseEnter={onToggle} onMouseLeave={onToggle}>
          <WarningIcon color="text.warning" boxSize="12px" />
          <Typography variant="detail" color="text.warning">
            {isWordReport
              ? 'The word report won’t include the total consolidated data as you don’t have access to all subsidiaries'
              : 'Please note that you don’t have access to all subsidiaries. Aggregated data is limited to subsidiaries you have access to and may not reflect group totals.'}
          </Typography>
        </HStack>
      </PopoverAnchor>
      <PopoverContent bg="bg.accent" border="none" w="250px" boxShadow="none !important">
        <PopoverArrow bg="bg.accent" border="none" />
        <Typography variant="body" padding="8px" color="text.onAccent">
          If you need access to group totals, please reach out to your admin user to gain access to
          additional subsidiaries.
        </Typography>
      </PopoverContent>
    </Popover>
  );
};
